// extracted by mini-css-extract-plugin
export default {"chip":"style__chip___Uy0gg","chipLabel":"style__chipLabel___2XCQK"};